import { useQuery } from '@apollo/client'
import { Skeleton } from '@faceup/ui-base'
import { NUMBER_FOR_NO_LIMIT } from '@faceup/utils'
import { graphql } from '../../__generated__'
import { defineMessages, FormattedMessage } from '../../TypedIntl'
import { FollowUpContent } from './FollowUpContent'
import ReportInfo from './ReportInfo'

const messages = defineMessages({
  title: 'FollowUp.report.title',
})

const query = {
  ReportQuery: graphql(`
    # not used but needed for useFormItemsAnswers_companyReport
    # Asymmetry vs akutan: akutan reads the per-case unread state via the
    # server-side unseenFollowUpCommentsCount / firstUnseenFollowUpComment
    # resolvers, but those are allowUserType: [Member] only. Until we expose a
    # victim-side equivalent we keep using the client-side
    # useUnreadFollowUpMessages hook here.
    query ReportQuery(
      $sourceLanguage: Language
      $targetLanguage: Language
      $followUpFirst: Int!
    ) {
      companyVictimViewer {
        id
        __typename
        email
        isEmailVerified

        case {
          id
          isDeleted
          status {
            id
            groupName
          }
          channel {
            id
            sourceType
            defaultLanguage
          }
          ...CompanyReportInfo_case
          followUpActivities(first: $followUpFirst) {
            __typename
            items {
              id
              ...useUnreadFollowUpMessages_followupComment
            }
          }
        }
        ...CompanyReportInfo_viewer
      }
    }
  `),
}

const Report = () => {
  const { data, loading } = useQuery(query.ReportQuery, {
    fetchPolicy: 'network-only',
    variables: { followUpFirst: NUMBER_FOR_NO_LIMIT },
  })

  const viewer = data?.companyVictimViewer ?? null
  const aCase = viewer?.case ?? null

  const followUpItems = aCase?.followUpActivities?.items ?? []

  return (
    <FollowUpContent
      checkRoute={routes => routes.checkReport()}
      title={<FormattedMessage {...messages.title} />}
      loading={loading}
      viewer={viewer}
      followUpItems={followUpItems}
      infoPanel={
        viewer && aCase ? (
          <ReportInfo loading={loading} case={aCase} viewer={viewer} />
        ) : (
          <Skeleton />
        )
      }
    />
  )
}

export default Report
